<template>
  <Modal :visible="true">
    <template #title>
      <span>Schedule Manually</span>
    </template>
    <template #default>
      <div class="schedule-manually-modal-content">
        <TextField v-model="scheduleIds" multiline label="Schedule IDs" />
        <span v-if="scheduleIdsArray.length" class="result">{{ scheduleIdsArray.length }} application(s) will be scheduled for processing.</span>
      </div>
    </template>
    <template #footer>
      <Button @click="$emit('close')">Close</Button>
      <Button v-if="scheduleIdsArray.length" color="secondary" @click="schedule">Schedule</Button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/common/Modal.vue';
import Button from '@/components/common/Button.vue';
import TextField from '@/components/common/TextField.vue';
export default {
  name: 'ScheduleManually',
  components: {
    Modal,
    Button,
    TextField
  },
  data() {
    return {
      scheduleIds: ''
    };
  },
  computed: {
    scheduleIdsArray() {
      const collection = this.scheduleIds && this.scheduleIds.match(new RegExp(/(PCT\/\w{2}\d{4}\/\d{5,6})|(\d{8,})/, 'gmi'));
      return Array.from(new Set(collection));
    }
  },
  methods: {
    async schedule() {
      const confirm = await this.$confirm({
        title: 'Manually schedule',
        message: `You are about to schedule ${this.scheduleIdsArray.length} application(s) for processing. Are you sure you want to continue?`,
        confirm: 'Schedule'
      });

      if (!confirm) {
        return;
      }
      this.$emit('schedule', this.scheduleIdsArray);
    }
  }
};
</script>
<style lang="scss" scoped>
.schedule-manually-modal-content {
  padding: 20px;

  .result {
    display: block;
    margin-top: 10px;
  }
}
</style>
